<template>
  <div class="page-spinner">
    <div class="logo-spinner-t1" />
  </div>
</template>

<script>
export default {
  name: 'BasePageSpinner'
}
</script>
